<div class="ac-variants-coverages-row-title">
    <div class="title__label"> {{ title }} </div>

    <app-tooltip-icon class="reset-position"
                      *ngIf="tooltip"
                      [outlined]="true"
                      [description]="tooltip">
    </app-tooltip-icon>
</div>
